import React from 'react'
import PropTypes from 'prop-types'

import OrderPointsAndCash from './OrderPointsAndCash'
import OrderInfo from './OrderInfo'
import AddressInfo from './AddressInfo'
import { About } from '../About'

const AboutOrder = props => (
  <About
    campaignHasDonation={props.campaignHasDonation}
    title=' Sobre o pedido'
  >
    <OrderPointsAndCash
      paymentDetailMoneyAndPoints={
        props.parentOrder.orderPaymentDetailMoneyAndPoints
      }
    />
    <OrderInfo parentOrder={props.parentOrder} />
    {
      (props.parentOrder && props.parentOrder.vendorOrderModel) &&
      props.parentOrder.vendorOrderModel[0].vendorType !== 'Milhas' &&
       props.parentOrder.vendorOrderModel[0].vendorType !== 'Doação' &&
        props.parentOrder.vendorOrderModel[0].vendorType !== 'Compra de Pontos' &&
        <AddressInfo
          address={props.parentOrder.address}
          receiver={props.parentOrder.receiver}
        /> }
  </About>
)

AboutOrder.propTypes = {
  parentOrder: PropTypes.object,
  campaignHasDonation: PropTypes.bool
}

export default AboutOrder



// WEBPACK FOOTER //
// ./src/features/AboutOrder/AboutOrder.js